<template>
  <div>
    <div ref="child_popper" class="popper-container">
      <div class="desc__info text-dark" v-if="isTooltip">
        <div v-html="activeSubjectTypeDesc" v-if="isTooltipPopperDone"></div>
      </div>
    </div>
    <div class="subject-types text-dark" :class="{'subject-types--focus': isFormElementActive}">
      <div class="subject-types__type"
           :class="{'subject-types__type--selected': selectedtype === subjectType.value}"
           v-for="subjectType in activeSubjectTypes" :key="subjectType.value"
           @click="selectedtype = subjectType.value">
        <input type="radio"
               v-model="selectedtype"
               :value="subjectType.value"
               name="subject[subject_type]"
               :id="'subject_subject_type_' + subjectType.value">
        <label :for="'subject_subject_type_' + subjectType.value" v-html="subjectType.name"></label>
        <div class="desc" ref="parent_popper" @mouseenter="showTooltip(subjectType.desc, $event)"
             @mouseleave="hideTooltip">
          <svg width="16px" height="16px" viewBox="0 0 16 16">
            <g id="Artboard-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Group-2">
                <circle id="Oval-10" fill="#a2a3a6" cx="8" cy="8" r="8"></circle>
                <path
                  d="M7.354,9.657 L7.354,9.294 C7.354,7.732 9.059,7.292 9.059,6.148 C9.059,5.51 8.652,5.191 8.014,5.191 C7.343,5.191 6.826,5.609 6.826,6.445 L5.473,6.445 C5.473,4.729 6.573,3.948 8.102,3.948 C9.389,3.948 10.533,4.608 10.533,6.005 C10.533,7.666 8.663,8.183 8.663,9.437 L8.663,9.657 L7.354,9.657 Z M7.156,11.373 C7.156,10.878 7.464,10.559 8.003,10.559 C8.509,10.559 8.85,10.878 8.85,11.34 C8.85,11.813 8.509,12.143 8.003,12.143 C7.464,12.143 7.156,11.813 7.156,11.373 Z"
                  id="?" fill="#FFFFFF"></path>
              </g>
            </g>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import docendo from '../../docendo'
import {createPopper} from '@popperjs/core'
import {allTypes, kindergartenTypes} from './subjectTypes'

export default {
  props: {
    calendarType: {
      default: 'klass'
    },
    subjectType: {
      default: ''
    },
    isInTasks: {
      type: Boolean,
      default: false
    },
    showActivities: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      calSubjectTypes: [],
      allTypes: allTypes,
      kindergartenTypes: kindergartenTypes,
      selectedtype: null,
      isTooltip: false,
      isTooltipPopperDone: false,
      activeSubjectTypeDesc: ''
    }
  },
  computed: {
    school () {
      return this.$store.state.activeSchool
    },
    schoolId () {
      return window.SCHOOL && window.SCHOOL.id ? window.SCHOOL.id : this.$route.params.school_id ? this.$route.params.school_id : this.school.id
    },
    locale () {
      return this.$store.getters.locale
    },
    isKindergarten () {
      return this.$store.getters.isKindergarten
    },
    isReductionsActive () {
      return this.$store.getters.isReductionsActive
    },
    localPoolTitle () {
      const title = this.$store.getters.localPoolTitle
      return title || this.$t('vue2.task_overview.pool')
    },
    activeSubjectTypes () {
      let arr = []
      let dbSubjectTypes = !this.isInTasks ? this.calSubjectTypes : this.calSubjectTypes.filter(type => !(type === 'other_stuff' || type === 'other_tasks'))
      const allTypes = this.isKindergarten ? this.kindergartenTypes : this.allTypes
      dbSubjectTypes.forEach(activeType => {
        if (allTypes[activeType] && allTypes[activeType].filter(subjectType => subjectType.lang === this.locale)[0]) {
          arr.push(allTypes[activeType].filter(subjectType => subjectType.lang === this.locale)[0])
        }
      })
      if (this.localPoolTitle) {
        arr = arr.map(subjectType => {
          if (subjectType.value === 'pool') {
            return {...subjectType, name: this.localPoolTitle}
          }
          return subjectType
        })
      }
      if (!this.isSchoolFeatureLocalePool) {
        arr = arr.filter(subjectType => subjectType.value !== 'pool')
      }
      if (this.calendarType === 'room') {
        arr = arr.filter(subjectType => subjectType.value !== 'subject')
      }
      if (this.calendarType === 'klass') {
        const idx = arr.findIndex(subjectType => subjectType.value === 'additional_tasks' && subjectType.lang === 'da')
        if (idx > -1) {
          arr[idx]['name'] = 'Tilsyn / Øvrige opgaver'
        }
      }
      return arr.filter(item => {
        if (item.value === 'activity' && !this.showActivities && this.subjectType !== 'activity') return false
        return true
      }).sort((a, b) => (a.order > b.order) ? 1 : -1)
    },
    isSchoolFeatureLocalePool () {
      return this.$store.getters.isSchoolFeatureLocalePool
    }
  },
  watch: {
    calendarType () {
      this.readSubjectTypes(this.calendarType)
    },
    selectedtype (val) {
      this.$emit('change', val)
    },
    activeSubjectTypes () {
      const idx = this.activeSubjectTypes.findIndex(subjectType => subjectType.value === this.subjectType)
      if (idx > 0 && this.subjectType) {
        this.selectedtype = this.subjectType
      } else {
        this.selectedtype = this.activeSubjectTypes[0].value
      }
    }
  },
  methods: {
    createPopper (evt) {
      const childPopper = this.$refs.child_popper
      document.getElementById('djs-content-container').appendChild(childPopper)
      createPopper(evt.target, childPopper, {
        placement: 'right',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: ({placement, reference, popper}) => {
                return [0, 5]
              }
            }
          }
        ]
      })
    },
    showTooltip (desc, evt) {
      this.activeSubjectTypeDesc = desc
      this.isTooltip = true
      this.$nextTick(_ => {
        this.createPopper(evt)
        this.isTooltipPopperDone = true
      })
    },
    hideTooltip () {
      this.activeSubjectTypeDesc = ''
      this.isTooltip = false
      this.isTooltipPopperDone = false
    },
    readSubjectTypes (calType) {
      const schoolCountry = this.school.country
      docendo.subjectsForCalendarType(calType, schoolCountry, success => {
        this.calSubjectTypes = success
      }, failure => {
        console.log('failed')
      })
    }
  },
  beforeMount () {
    if (this.activeSubjectTypes && this.activeSubjectTypes[0]) {
      this.subjectType ? this.selectedtype = this.subjectType : this.selectedtype = this.activeSubjectTypes[0].value
    }
  },
  mounted () {
    this.readSubjectTypes(this.calendarType)
  },
  beforeDestroy () {
    // remove the dropdown from the DOM
    const childPopper = this.$refs.child_popper
    if (childPopper) {
      childPopper.remove()
    }
  }
}
</script>

<style scoped>
@import '../../assets/css/variables.css';


.subject-types {
  display: inline-flex;
  flex-direction: column;
  border-radius: 4px;
  min-width: 300px;
  width: 100%;
}

.subject-types:focus-within {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 0px 0px 2px rgba(58, 151, 212, 0.5) !important;
}

.subject-types__type {
  position: relative;
  display: inline-flex;
  align-items: center;
  line-height: 16px;
  transition: color 0.25s;
  cursor: pointer;
  padding: 1rem;
  margin-bottom: 0;
  width: 100%;
  border: 1px solid #e5e7eb;
  border-width: 1px 1px 0 1px;
}

.subject-types__type.subject-types__type--selected + .subject-types__type {
  border-top: none;
}

.subject-types__type.subject-types__type--selected,
.subject-types .subject-types__type.subject-types__type--selected:last-child {
  background: #eff2ff;
  border: 1px solid #c8d2fe;
}

.subject-types__type > input[type="radio"] {
  width: auto;
  padding-right: 8px;
}

.subject-types__type > input[type="radio"]:checked + label {
  color: var(--dark-blue);
}

.subject-types__type label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0;
  font-size: 12px;
  padding-left: 10px;
  cursor: pointer;
  transition: color 0.25s;
  letter-spacing: .075rem;
  font-weight: 700;
  text-transform: uppercase;
  line-height: 1rem;
  color: #a2a3a6;
}

.desc {
  position: absolute;
  right: 1rem;
  padding-left: 10px;
  display: flex;
  cursor: help;
}

.desc__info {
  z-index: 123123;
  position: absolute;
  bottom: 0;
  left: 100%;
  min-width: 200px;
  max-width: 420px;
  background-color: #ffffff;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: opacity 0.25s, transform 0.25s;
  font-weight: bold;
}

.subject-types__type:hover label {
  color: var(--dark-blue);
}

.popper-container {
  position: absolute;
  z-index: 123123;
}

.subject-types .subject-types__type:first-child {
  border-radius: 4px 4px 0 0;
}

.subject-types .subject-types__type:last-child {
  border-radius: 0 0 4px 4px;
  border-bottom: 1px solid #e5e7eb;
}

.subject-types .subject-types__type:only-child {
  border-radius: 4px;
}

</style>



// WEBPACK FOOTER //
// SubjectFormSubjectType.vue?907b5568